export default __webpack_public_path__ + "static/media/avatar_unicorn5.66974dcb.mp3";